import { Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import NavBarAdmin from './NavBarAdmin';
import { AppData } from "../../Data/Models/AppData";
import FormAddApp from './FormAddApp';
import { mainCollection, storage } from "../../config/firebase";
import { deleteDoc, DocumentData, getDocs, QueryDocumentSnapshot } from 'firebase/firestore';
import AdminProjects from './AdminProjects';
import { deleteObject, ref } from 'firebase/storage';

function Admin() {

  const [open, setOpen] = React.useState(false);
  const [data, setData] = useState<AppData[]>([])
  const [dataRaw, setDataRaw] = useState<QueryDocumentSnapshot<DocumentData>[]>([])
  const [editData, setEditData] = useState<QueryDocumentSnapshot<DocumentData> | null>(null)
  const [refresh, setRefresh] = React.useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const querySnapshot = await getDocs(mainCollection);
      const myCollectionDataRaw = querySnapshot.docs;
      const myCollectionData = myCollectionDataRaw.map((doc) => doc.data());

      setDataRaw(myCollectionDataRaw)
      setData(myCollectionData as AppData[])
    };

    fetchData();
  }, [refresh]);

  const handleAdd = () => {
    if (editData) {
      setEditData(null)
    } else {
      setOpen(true)
    }
  }

  const handleEdit = (index: number) => {
    if (editData) {
      setEditData(dataRaw[index])
      setOpen(true)
    } else {
      setEditData(dataRaw[index])
    }
  }

  const deleteFromStorage = (appDat: AppData) => {
    const iconRef = ref(storage, appDat.iconUrl)
    const featureRef = ref(storage, appDat.featureImageUrl)
    deleteObject(iconRef).then(() => {
      console.log("Icon Deleted")
    }).catch((error) => {
      console.log("Error Deleting Icon")
      console.log(error)
    })
    deleteObject(featureRef).then(() => {
      console.log("Feture Image Deleted")
    }).catch((error) => {
      console.log("Error Deleting Feture Image")
      console.log(error)
    })
    appDat.screenshotUrls.forEach((dat) => {
      const refScreen = ref(storage, dat)
      deleteObject(refScreen).then(() => {
        console.log("Screenshot Deleted")
      }).catch((error) => {
        console.log("Error Deleting Screenshot")
        console.log(error)
      })
    })
  }

  const handleDelete = (index: number) => {
    const raw = dataRaw[index]
    const dat =  raw.data() as AppData
    deleteDoc(raw.ref).then(() => {
      console.log("Deleted")
      deleteFromStorage(dat)
      setRefresh(!refresh)
    }).catch((error) => {
      console.log("Failed Deleting document")
      console.log(error)
    })
  }

  useEffect(() => {
    setOpen(true)
    console.log(editData)
  }, [editData])

  return (
    <>
      <NavBarAdmin add={() => { handleAdd() }} />
      <Stack spacing={2} justifyContent="space-between">
        <AdminProjects data={data} edit={(index) => {
          handleEdit(index)
        }} delete={(index) => {
          handleDelete(index)
        }}></AdminProjects>
        <FormAddApp toggle={[open, setOpen]} updateData={editData}></FormAddApp>
      </Stack>
    </>
  );
}

export default Admin;
